import React from "react";

const ProductUSPHighlightView = ({ productDetail, productUps, media_types, content_types }) => {
  const genFileIndex = (file) => {
    const name = file.fileName || file.name || file.file_name;
    return name.split(" ").join("");
  };

  return (
    <div>
      <div className="my-3 px-2">
        <i className="fa fa-camera" /> USP Product Highlight
      </div>

      {productUps?.length === 0 && (
        <div className="my-5 text-center">
          <p className="text-muted">No USP product highlight available</p>
        </div>
      )}

      <div className="row">
        {productUps?.map((file, index) => {
          let fileIndex = genFileIndex(file);
          if (!productUps[fileIndex] && file.fileIndex) fileIndex = file.fileIndex;

          const showTagsFromSameLanguage = file.tags && file.tags.find((i) => i.language_code == productDetail.language_code);

          return (
            <div className="col-md-4 mb-3" key={index}>
              <div className="d-flex align-items-center">
                <div style={{ width: "50%", height: 200 }}>
                  <img
                    src={file.url}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      borderRadius: 4,
                      marginBottom: 20,
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="mx-3">
                  {showTagsFromSameLanguage && (
                    <>
                      <div>
                        <div className="text-secondary">Title</div>
                        <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
                          {file.tags.find((i) => i.language_code == productDetail.language_code)?.title || "-"}
                        </p>
                      </div>
                      <div>
                        <div className="text-secondary">Description</div>
                        <p className="text-break" style={{ whiteSpace: "pre-wrap" }}>
                          {file.tags.find((i) => i.language_code == productDetail.language_code)?.description || "-"}
                        </p>
                      </div>
                    </>
                  )}
                  <div className="mb-3">
                    <div className="text-secondary">Image Types</div>
                    {file?.media_type?.map((item) => {
                      const mediaType = media_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {mediaType ? mediaType.name : item}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <div className="text-secondary">Content Types</div>
                    {file?.content_type?.map((item) => {
                      const contentType = content_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {contentType ? contentType.name : item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductUSPHighlightView;
